module.exports = __webpack_public_path__ + "static/media/instagram.13ab1567.svg";